import { axios } from '@/utils/request'

/**
 * 查询设备列表
 * @param {page:number,page_size:number,branch_id?:number}
 * @returns 
 */
export function getEquipmentList(params) {
  return axios({
    url: `/doll_machines`,
    method: 'get',
    params
  })
}

/**
 * 新增/修改设备
 * @param {id:number,no:number,branch_id?:number}
 * @returns 
 */
export function updateEquipment(params){
  return axios({
    url: `/doll_machine/save`,
    method: 'post',
    data:params
  })
}

/**
 * 删除设备
 * @param  id 记录id
 * @returns 
 */
export function deleteEquipment(id) {
  return axios({
    url: `/doll_machine/${id}`,
    method: 'delete',
    params:id
  })
}
/**
 * 查询设备信息
 * @param  id 记录id
 * @returns 
 */
export function getEquipmentInfo(id) {
  return axios({
    url: `/doll_machine/${id}`,
    method: 'get',
    params:id
  })
}

// 获取设备抄表数据
/**
 * 查询设备信息
 * @param params {page:number,page_size:number}
 * @returns 
 */
export function getEquipmentData(params) {
  return axios({
    url: `/doll_machine/${params.id}/readings`,
    method: 'get',
    params
  })
}